import { User } from "../user/user.model";
import { Rate } from "./rate-type";
import { RateLocation } from "./rate-location/rate-location.type";
import { Carrier } from "../carrier/carrier.model";
import { Client } from "../client/client.model";
import { BaseRate } from "./rate-base.model";
import { Location } from "../location/location.model";

export class BaseLinkedRate extends BaseRate {
  constructor(
    protected id: number,
    protected name: string,
    protected discriminator: string,
    protected createdBy?: User,
    protected updatedBy?: User,
    protected createdAt?: Date,
    protected updatedAt?: Date,
    protected type?: string,
    protected source?: string,
    protected status?: string,
    protected internalNote?: string,
    protected externalNote?: string,
    protected pmNote?: string,
    protected comment?: string,
    protected deepLink?: string,
    protected carrier?: Carrier,
    protected validity?: Date[],
    protected currency?: string,
    protected originLocation?: RateLocation,
    protected destinationLocation?: RateLocation,
    protected contractNumber?: string,
    protected restrictedClients?: Client[],
    protected restrictedUsers?: User[],
    protected rootParent?: Rate,
  ) {
    super(
      id,
      name,
      discriminator,
      createdBy,
      updatedBy,
      createdAt,
      updatedAt,
      type,
      source,
      status,
      internalNote,
      externalNote,
      pmNote,
      comment,
      deepLink,
      carrier,
      validity,
      contractNumber,
      restrictedClients,
      restrictedUsers,
      rootParent,
    );
  }

  public getOriginLocation(): RateLocation {
    return this.originLocation;
  }

  public setOriginLocation(param: RateLocation): void {
    this.originLocation = param;
  }

  public getDestinationLocation(): RateLocation {
    return this.destinationLocation;
  }

  public setDestinationLocation(param: RateLocation): void {
    this.destinationLocation = param;
  }

  public getCurrency(): string {
    return this.currency;
  }

  public setCurrency(param: string): void {
    this.currency = param;
  }

  public get realOriginLocation(): Location {
    return this.originLocation ? this.originLocation.getLocation() : null;
  }

  public get realDestinationLocation(): Location {
    return this.destinationLocation
      ? this.destinationLocation.getLocation()
      : null;
  }

  public hasLocationsSelected(): boolean {
    return !!this.getOriginLocation() && !!this.getDestinationLocation();
  }

  public isValid(): boolean {
    return (
      !!this.name &&
      !!this.carrier &&
      !!this.validity &&
      !!this.hasLocationsSelected()
    );
  }
}
